import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../redux/hooks';
import { lddStateObject, setShowLenderCentre, setShowLenderCredentialsError } from '../../redux/reducer';
import { runInnerFunction } from '../../compatManager';

export const LenderCentre: React.FC = () => {
    const dispatch = useDispatch();

    const showLenderCentre = useAppSelector((state: lddStateObject) => state.ShowLenderCentre);
    const showLenderCredentialsError = useAppSelector((state: lddStateObject) => state.ShowLenderCredentialsError);

    const handleCloseLenderCentre = () => {
        dispatch(setShowLenderCentre(false));
    };

    const handleCloseLenderCredentialsError = () => {
        dispatch(setShowLenderCredentialsError(false));
    };

    if (!showLenderCentre && !showLenderCredentialsError) {
        return null;
    }

    return (
        <>
            <Modal centered show={showLenderCentre} size="lg">
                <Modal.Header>
                    <h2>Lender Centre</h2>
                </Modal.Header>
                <Modal.Body>
                    <h2>Lender Centre is not connected.</h2>
                    
                    <p>
                        To import mortgage instructions accepted through Lender Centre into your RealtiWeb
                        file, please go to your user settings and fill out the Lender Centre information required.
                    </p>

                    <p className="text-muted">
                        For additional information, refer to <a href="#" onClick={() => runInnerFunction('openZoho', 'articles/importing-mortgage-instructions-from-lender-centre')} className="text-primary">this article</a> or contact Support.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseLenderCentre}>Close</Button>
                </Modal.Footer>
            </Modal>

            <Modal centered show={showLenderCredentialsError} size="lg">
                <Modal.Header>
                    <h2>Lender Centre</h2>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="danger">
                        Your Lender Centre credentials may be incorrect.
                    </Alert>
                    <p>
                        Please go to your user settings and ensure the Lender Centre information required is
                        correct and has been verified.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseLenderCredentialsError}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};